// Custom Search Bar JavaScript - Vanilla JS Implementation
(function() {
    'use strict';
    
    var customYmmAPI = window.ymmApiBaseUrl || "https://partsology.com/apps/ymm-dev";

    // Debounce function to prevent excessive API calls
    function debounce(func, delay) {
        var timeoutId;
        return function() {
            var context = this;
            var args = arguments;
            clearTimeout(timeoutId);
            timeoutId = setTimeout(function() {
                func.apply(context, args);
            }, delay);
        };
    }

    // Throttle function for scroll events
    function throttle(func, delay) {
        var timeoutId;
        var lastExecTime = 0;
        return function() {
            var context = this;
            var args = arguments;
            var currentTime = Date.now();
            
            if (currentTime - lastExecTime > delay) {
                func.apply(context, args);
                lastExecTime = currentTime;
            } else {
                clearTimeout(timeoutId);
                timeoutId = setTimeout(function() {
                    func.apply(context, args);
                    lastExecTime = Date.now();
                }, delay - (currentTime - lastExecTime));
            }
        };
    }

    // Initialize when DOM is loaded
    document.addEventListener('DOMContentLoaded', function() {
        initializeCustomSearch();
    });

    // Also try to initialize when window loads (as backup)
    window.addEventListener('load', function() {
        if (!document.getElementById("custom_header_search_input")) {
            setTimeout(initializeCustomSearch, 100);
        }
    });

    function initializeCustomSearch() {
        
        var searchInput = document.getElementById("custom_header_search_input");
        var submitButton = document.querySelector(".custom-search-bar--submit");
        var searchLoader = document.querySelector(".custom-search-loader");
        var searchResults = document.querySelector(".custom-fitment_search_result");
        var searchDiv = document.querySelector(".custom-fitment_search_div");
        var searchBar = document.querySelector(".custom-search-bar");
             
        if (!searchInput) {
            return;
        }

        var search_avail = 1;
        var suggest_avail = 0;
        var enterKeyHandler = null;
        var currentRequest = null;
        var default_image = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40'%3E%3Crect width='40' height='40' fill='%23f0f0f0'/%3E%3Ctext x='50%25' y='50%25' font-size='10' text-anchor='middle' dy='0.35em' fill='%23999'%3ENo Image%3C/text%3E%3C/svg%3E";
        
        // Variables for infinite scroll
        var allResults = [];
        var currentResultType = '';
        var currentSearchTerm = '';
        var resultsPerPage = 50;
        var currentPage = 0;
        var isLoadingMore = false;

        // Handle input events for submit button visibility
        searchInput.addEventListener('input', function() {
            var header_input_length = searchInput.value.length;
            
            if (header_input_length > 0) {
                if (submitButton) submitButton.style.display = 'none';
                
                // Remove existing event listener if any
                if (enterKeyHandler) {
                    searchInput.removeEventListener("keypress", enterKeyHandler);
                }
                
                // Add new event listener to handle Enter key properly
                enterKeyHandler = function(event) {
                    if (event.key === "Enter") {
                        event.preventDefault();
                        // Submit the search form when Enter is pressed
                        var searchForm = document.getElementById('custom_header_search');
                        if (searchForm) {
                            searchForm.submit();
                        }
                        return false;
                    }
                };
                searchInput.addEventListener("keypress", enterKeyHandler);
                
            } else {
                if (submitButton) submitButton.style.display = 'block';
                
                // Remove enter key prevention when input is empty
                if (enterKeyHandler) {
                    searchInput.removeEventListener("keypress", enterKeyHandler);
                    enterKeyHandler = null;
                }
                
                // Clear results when input is empty
                clearResults();
            }
        });

        function clearResults() {
            if (searchDiv) searchDiv.style.display = "none";
            if (searchResults) {
                searchResults.innerHTML = "";
                searchResults.classList.remove("active-results");
            }
            if (searchBar) searchBar.classList.remove("search-active");
            allResults = [];
            currentPage = 0;
            isLoadingMore = false;
        }

        function renderResults(startIndex, append) {
            if (!searchResults || allResults.length === 0) return;
            
            var endIndex = Math.min(startIndex + resultsPerPage, allResults.length);
            var list_html = "";
            var isLastBatch = endIndex >= allResults.length;
            
            // Add header only on first load
            if (!append && currentResultType === "suggest_search") {
                list_html += '<li class="first_list"><h3 id="predictive-search" class="predictive-search-title__content">Products</h3></li>';
            }
            
            for (var i = startIndex; i < endIndex; i++) {
                var item = allResults[i];
                var main_image = "";
                
                if (item["main_image"] && item["main_image"] !== "") {
                    main_image = item["main_image"];
                } else {
                    main_image = default_image;
                }
                
                if (currentResultType === "suggest_search") {
                    list_html += '<li id="search-result-' + i + '" class="predictive-search-item" role="option" data-search-result="">' +
                        '<a class="predictive-search-item__link" href="/products/' + (item["url"] || '') + '?_pos=' + (i + 1) + '&_psq=' + encodeURIComponent(currentSearchTerm) + '&_ss=e&_v=1.0" tabindex="-1">' +
                        '<div class="predictive-search__column predictive-search__column--image" data-image-with-placeholder-wrapper="">' +
                        '<div class="placeholder-background placeholder-background--animation hide" data-image-placeholder="" aria-hidden="true"></div>' +
                        '<img class="predictive-search-item__image" src="' + main_image + '" data-image="" alt="' + (item["product_name"] || '') + '" loading="lazy">' +
                        '</div>' +
                        '<div class="predictive-search__column predictive-search__column--content predictive-search__column--center">' +
                        '<span class="predictive-search-item__title">' +
                        '<span class="predictive-search-item__title-text">' + (item["product_name"] || '') + '</span>&nbsp;' +
                        '<span class="predictive-search-item-sku">#' + (item["handle"] || '') + '</span>' +
                        '</span>' +
                        '</div>' +
                        '</a>' +
                        '</li>';
                } else {
                    if (currentResultType === "fitment_search") {
                        list_html += '<li><a href="/collections/catalog?ymm_year=' + encodeURIComponent(item["value_name4"] || '') + 
                            '&ymm_make=' + encodeURIComponent(item["value_name3"] || '') + 
                            '&ymm_model=' + encodeURIComponent(item["value_name2"] || '') + 
                            '&ymm_engine=' + encodeURIComponent(item["value_name1"] || '') + 
                            '&ymm_part_type=' + encodeURIComponent(item["value_name"] || '') + 
                            '&view=list">' + 
                            (item["value_name4"] || '') + ' ' + (item["value_name3"] || '') + ' ' + (item["value_name2"] || '') + ' ' + (item["value_name1"] || '') + ' ' + (item["value_name"] || '') + 
                            '</a></li>';
                    } else {
                        list_html += '<li><a href="/collections/catalog?ymm_year=' + encodeURIComponent(item["value_name4"] || '') + 
                            '&ymm_make=' + encodeURIComponent(item["value_name3"] || '') + 
                            '&ymm_model=' + encodeURIComponent(item["value_name2"] || '') + 
                            '&ymm_engine=' + encodeURIComponent(item["value_name1"] || '') + 
                            '&view=list">' + 
                            (item["value_name4"] || '') + ' ' + (item["value_name3"] || '') + ' ' + (item["value_name2"] || '') + ' ' + (item["value_name1"] || '') + 
                            '</a></li>';
                    }
                }
            }
            
            // Add loading indicator if there are more results (not last batch)
            if (!isLastBatch) {
                list_html += '<li id="load-more-indicator" class="predictive-search-item no-result" style="padding:15px;text-align:center;color:#666;font-style:italic;">Scroll down to load more results... (' + endIndex + ' of ' + allResults.length + ' shown)</li>';
            }
            
            // Add "View All" button only at the very end when all results are loaded
            if (isLastBatch && currentResultType === "suggest_search") {
                list_html += '<li class="last_list"><button type="submit" class="predictive-search-view-all__button" tabindex="-1">Search for<span class="predictive-search-view-all__query"> "' + currentSearchTerm + '"</span> (' + allResults.length + ' total results)</button></li>';
            }
            
            if (append) {
                // Remove old loading indicator and view all button
                var oldIndicator = document.getElementById('load-more-indicator');
                if (oldIndicator) oldIndicator.remove();
                
                var oldViewAll = document.querySelector('.predictive-search-view-all__button');
                if (oldViewAll && oldViewAll.parentNode) {
                    oldViewAll.parentNode.remove();
                }
                
                // Append new results
                searchResults.insertAdjacentHTML('beforeend', list_html);
            } else {
                searchResults.innerHTML = list_html;
            }
            
        }

        // Throttled scroll handler for infinite scroll
        var handleScroll = throttle(function() {
            if (!searchDiv || searchDiv.style.display === "none" || isLoadingMore) return;
            
            var scrollTop = searchDiv.scrollTop;
            var scrollHeight = searchDiv.scrollHeight;
            var clientHeight = searchDiv.clientHeight;
            
            // Load more when scrolled to bottom 80%
            if (scrollTop + clientHeight >= scrollHeight * 0.8) {
                var nextStartIndex = (currentPage + 1) * resultsPerPage;
                if (nextStartIndex < allResults.length) {
                    isLoadingMore = true;
                    console.log('Custom search bar: Loading more results...');
                    
                    // Add a slight delay to show loading state
                    setTimeout(function() {
                        currentPage++;
                        renderResults(nextStartIndex, true);
                        isLoadingMore = false;
                    }, 100);
                }
            }
        }, 150);

        // Add scroll listener to search results container
        if (searchDiv) {
            searchDiv.addEventListener('scroll', handleScroll);
        }

        // Debounced search function
        var debouncedSearch = debounce(function() {
            var search_top_val = searchInput.value.trim();
            var search_top_val_len = search_top_val.length;
                        
            if (search_top_val_len > 3) {
                // Cancel previous request if still pending
                if (currentRequest) {
                    currentRequest.abort();
                }
                
                suggest_avail++;
                if (searchLoader) searchLoader.style.display = "flex";
                if (searchDiv) searchDiv.style.display = "block";
                if (searchResults) searchResults.classList.add("active-results");
                if (searchBar) searchBar.classList.add("search-active");

                // Create AbortController for request cancellation
                var controller = new AbortController();
                currentRequest = controller;

                var apiUrl = customYmmAPI + "?type=ajax-search&search=fit_search&fitment_val=" + encodeURIComponent(search_top_val) + "&dataType=json";
                                
                fetch(apiUrl, { signal: controller.signal })
                    .then(function(response) {
                        return response.json();
                    })
                    .then(function(data) {
                        console.log('Custom search bar: API data:', data);
                        currentRequest = null;
                        suggest_avail--;
                        
                        var search_value = data.search_val;
                        var ymm_list = data.ymm_list;

                        if (ymm_list && ymm_list.length > 0) {
                            // Here we have filtered out products with 'Not_visible_individually' tag and zero price products
                            filterProductsByTags(ymm_list).then(function(filteredResults) {
                                allResults = filteredResults;
                                currentResultType = data.type;
                                currentSearchTerm = search_top_val;
                                currentPage = 0;
                                isLoadingMore = false;
                                
                                if (filteredResults.length > 0) {
                                    console.log('Custom search bar: Showing', filteredResults.length, 'available products out of', ymm_list.length, 'total results');
                                    renderResults(0, false);
                                    
                                    if (searchDiv) searchDiv.style.display = "block";
                                    if (searchLoader) searchLoader.style.display = "none";
                                    if (searchBar) searchBar.classList.add("search-active");
                                } else {
                                    if (search_value == searchInput.value && searchResults) {
                                        var list_html = '<li id="search-result" class="predictive-search-item no-result" role="option" data-search-result="">No search result found!</li>';
                                        searchResults.innerHTML = list_html;
                                        if (searchLoader) searchLoader.style.display = "none";
                                    }
                                }
                            }).catch(function(error) {
                                console.error('Custom search bar: Error filtering products:', error);
                                allResults = ymm_list;
                                currentResultType = data.type;
                                currentSearchTerm = search_top_val;
                                currentPage = 0;
                                isLoadingMore = false;
                                
                                renderResults(0, false);
                                
                                if (searchDiv) searchDiv.style.display = "block";
                                if (searchLoader) searchLoader.style.display = "none";
                                if (searchBar) searchBar.classList.add("search-active");
                            });
                            
                        } else {
                            if (search_value == searchInput.value && searchResults) {
                                var list_html = '<li id="search-result" class="predictive-search-item no-result" role="option" data-search-result="">No search result found!</li>';
                                searchResults.innerHTML = list_html;
                                if (searchLoader) searchLoader.style.display = "none";
                            }
                        }
                    })
                    .catch(function(error) {
                        currentRequest = null;
                        if (error.name === 'AbortError') {
                            return;
                        }
                        console.error('Custom search bar: Search API error:', error);
                        if (searchLoader) searchLoader.style.display = "none";
                        if (searchResults) searchResults.innerHTML = '<li class="predictive-search-item no-result">Error loading search results</li>';
                    });
                    
            } else {
                clearResults();
            }
        }, 300); // 300ms debounce delay

        // Handle search suggestions with debouncing
        searchInput.addEventListener('input', debouncedSearch);

        // Handle clicks outside search to close results
        document.addEventListener('click', function(event) {
            if (searchBar && !searchBar.contains(event.target)) {
                clearResults();
            }
        });

        // Handle search view all button click
        document.addEventListener('click', function(event) {
            if (event.target.classList.contains('predictive-search-view-all__button')) {
                event.preventDefault();
                var searchForm = document.getElementById('custom_header_search');
                if (searchForm) {
                    searchForm.submit();
                }
            }
        });
        
        // Here we have made a function to filter Not_visible_individually, zero price, and out-of-stock products using GraphQL
        async function filterProductsByTags(products) {
            if (!products || products.length === 0) {
                return products;
            }

            var filteredProducts = [];
                     
            var batchSize = 10;
            for (var i = 0; i < products.length; i += batchSize) {
                var batch = products.slice(i, i + batchSize);
                var batchPromises = batch.map(function(product) {
                    return getProductData(product.url || product.handle).then(function(productData) {
                        var hasExcludedTag = productData.tags && productData.tags.includes('Not_visible_individually');
                        var hasZeroPrice = product.price === 0 || product.price === '0';
                        var isOutOfStock = !productData.isAvailable;
                        
                        if (!hasExcludedTag && !hasZeroPrice && !isOutOfStock) {
                            return product;
                        }
                        return null;
                    }).catch(function(error) {
                        console.warn('Custom search bar: Error fetching product data for:', product.url || product.handle, error);
                        var hasZeroPrice = product.price === 0 || product.price === '0';
                        return hasZeroPrice ? null : product;
                    });
                });
                
                var batchResults = await Promise.all(batchPromises);
                filteredProducts = filteredProducts.concat(batchResults.filter(function(product) {
                    return product !== null;
                }));
            }
            
            return filteredProducts;
        }

        // Here we have made a function to get product tags and inventory data via GraphQL
        async function getProductData(productHandle) {
            if (!productHandle) {
                return { tags: [], isAvailable: true };
            }

            var GRAPHQL_URL = 'https://' + (window.Shopify && window.Shopify.shop ? window.Shopify.shop : location.hostname) + '/api/2021-07/graphql.json';
            var STOREFRONT_ACCESS_TOKEN = '831088b6df20c6ffcaeab13ec9c5fd6a'; // Using the same token from other parts of the codebase
            
            var productQuery = `
                query {
                    productByHandle(handle: "${productHandle}") {
                        tags
                        priceRange {
                            minVariantPrice {
                                amount
                            }
                        }
                        availableForSale
                        variants(first: 250) {
                            edges {
                                node {
                                    availableForSale
                                    quantityAvailable
                                }
                            }
                        }
                    }
                }`;

            try {
                var response = await fetch(GRAPHQL_URL, {
                    method: 'POST',
                    headers: {
                        'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ query: productQuery }),
                });

                var data = await response.json();
                
                if (data.data && data.data.productByHandle) {
                    var product = data.data.productByHandle;
                    var isAvailable = product.availableForSale;
                    
                    if (!isAvailable && product.variants && product.variants.edges) {
                        isAvailable = product.variants.edges.some(function(edge) {
                            return edge.node.availableForSale && edge.node.quantityAvailable > 0;
                        });
                    }
                    
                    return {
                        tags: product.tags || [],
                        isAvailable: isAvailable
                    };
                }
                
                return { tags: [], isAvailable: true };
            } catch (error) {
                console.error('Custom search bar: Error fetching product data:', error);
                return { tags: [], isAvailable: true }; 
            }
        }
        
    }

    // Helper function to encode URI components safely
    function safeEncodeURIComponent(str) {
        try {
            return encodeURIComponent(str || '');
        } catch (e) {
            return str || '';
        }
    }
})(); 